import getConfig from 'src/utils/getConfig';

/*
Grouped capabilities
- keys
- app mode config
- urls
- internationalization
- dictionary
- logos
- session behaviour
- quote_prefilling
- business_entity_specs
- client_interaction
- customer_facing
- dashboard
- tables
- my_agency
- agent_portal
- contact_info
- agency_address
- onboarding
- compliance
- tooltips
*/

// keys
export const gMapApiKey = getConfig('gMapApiKey');
export const filepickerApiKey = getConfig('FILEPICKER_API_KEY', '');
export const filepickerPolicy = getConfig('FILEPICKER_POLICY', '');
export const filepickerSignature = getConfig('FILEPICKER_SIGNATURE', '');

// app mode config
export const themeId = getConfig('themeId');
export const appMode = getConfig('applicationMode', {});
export const appModeUuid = getConfig('applicationMode.uuid', {});
export const appModeName = getConfig('applicationMode.name');
export const release = getConfig('release');
export const buildVersion = getConfig('BUILD_CODE_VERSION');
export const environment = getConfig('env');

// urls
export const redirectUrlsMap = getConfig('applicationMode.redirections', []);
export const baseUrl = getConfig('baseUrl');
export const prefixPath = getConfig('prefixPath');
export const backendApiUrl = getConfig('backendApiUrl');
export const staticFilesUrl = getConfig('staticFilesUrl', '');
export const quotesFrontendUri = getConfig('quotesUrl');
export const adviceUrl = getConfig('adviceUrl');
export const documentsServiceUrl = getConfig('documentsUrl');
export const appetiteUrl = getConfig('guideUrl');
export const resourcesUrl = getConfig('resourcesUrl');
export const commonStaticFilesUrl = getConfig('commonStaticFilesUrl');

// internationalization
export const internationalization = getConfig('internationalization', {});
export const defaultLanguage = internationalization.defaultLanguage || 'en-US';
export const defaultCurrency = internationalization.currency || 'USD';
export const phoneMaxLength = internationalization?.phone?.maxLength || 10;
export const phoneMinLength = internationalization?.phone?.minLength || 10;

export const supportEmail = getConfig(
  'applicationMode.contact_info.emails.agent_help_email',
);
export const supportPhone = getConfig(
  'applicationMode.contact_info.phones.agent_help_phone',
);

// logos
export const platformLogo = getConfig('platformLogo');
export const isPoweredByCWTextShown = getConfig(
  'applicationMode.agent_portal.layout.is_powered_by_cw_text_shown',
);
export const poweredByCwLogoUrl = getConfig('platformLogo.poweredByCwUrl');
export const logoUrl = getConfig('platformLogo.agentHeaderUrl');

// quote_prefilling
export const isFiscalIdRequired = getConfig(
  'applicationMode.agent_portal.quote_prefilling.quoting_requires_fiscal_id',
);
export const isContinueWithoutCUITLinkDisabled = getConfig(
  'applicationMode.agent_portal.quote_prefilling.is_continue_without_CUIT_link_disabled',
);

// business_entity_specs
export const importedSources = getConfig(
  'applicationMode.business_entity_specs.policy.imported_sources',
  [],
);

// client_interaction
export const showRetainSaleOpportunity = getConfig(
  'applicationMode.client_interaction.block_opportunity',
);

// customer_facing
export const isAddNewAgentEnabled = getConfig(
  'applicationMode.customer_facing.my_coverwallet.add_new_agent.enabled',
  true,
);
export const phoneNumberPattern = getConfig(
  'applicationMode.customer_facing.phone_number_pattern',
  '[0-9]*',
);
export const hideHeaderAgentPhone = getConfig(
  'applicationMode.customer_facing.hide_header_agent_phone',
  false,
);

// dashboard
export const seeMyAccountsOnly = getConfig(
  'applicationMode.agent_portal.dashboard.see_my_accounts_only',
  false,
);
export const enabledDashboardLinks = getConfig(
  'applicationMode.agent_portal.quick_links',
  [],
);

// tables
export const isApplyFilterByDataFromUrlEnabled = getConfig(
  'applicationMode.agent_portal.accounts.apply_filter_by_data_from_url.enabled',
  false,
);
export const premiumToDisplay = getConfig(
  'applicationMode.agent_portal.accounts.active_accounts.premium_to_display',
);
export const prospectsTableConfigRows = getConfig(
  'applicationMode.agent_portal.prospects_table',
);
export const isAdviceButtonEnabled = getConfig(
  'applicationMode.agent_portal.accounts.opportunities.advice_button.enabled',
);
export const disableAcordsActions = getConfig(
  'applicationMode.agent_portal.dashboard.disable_acords_actions',
);

// my_agency
export const disabledWhenVerified = getConfig(
  'applicationMode.agent_portal.my_agency.disabled_when_verified',
  [],
);
export const customAgencyQuestions = getConfig(
  'applicationMode.agent_portal.my_agency.custom_questions',
  [],
);
export const showPrincipalAgentField = getConfig(
  'applicationMode.agent_portal.my_agency.show_principal_agent_field',
);

// agent_portal
export const closeOpportunityReasons = getConfig(
  'applicationMode.agent_portal.close_opportunity_reasons',
  [],
);
export const isEditPrincipalAgentAllowed = getConfig(
  'applicationMode.agent_portal.agent_profile.allow_edit_principal_agent',
);
export const isSelfEmailEnabled = getConfig(
  'applicationMode.agent_portal.self_email_update.enabled',
);
export const pagesWithDisabledIntercom = getConfig(
  'applicationMode.agent_portal.intercom.pages_with_disabled_intercom',
  [],
);

// contact_info
export const showNotificationAlert = getConfig(
  'applicationMode.agent_portal.agency_contact_info.show_notification_alert',
  false,
);
export const fieldsToValidate = getConfig(
  'applicationMode.agent_portal.agency_contact_info.fields_to_show_notification_alert',
  [],
);
export const showABN = getConfig(
  'applicationMode.agent_portal.agency_contact_info.show_abn_field',
  false,
);
export const showAdditionalFields = getConfig(
  'applicationMode.agent_portal.agency_contact_info.show_additional_fields',
  true,
);
export const dbaFieldRequired = getConfig(
  'applicationMode.agent_portal.agency_contact_info.validations.dba.required',
  false,
);

// agency_address
export const shouldShowCityField = getConfig(
  'applicationMode.agent_portal.agency_address.show_city_field',
  false,
);

export const shouldShowStateField = getConfig(
  'applicationMode.agent_portal.agency_address.show_state_field',
  false,
);

export const shouldShowHasSamePostalAddressField = getConfig(
  'applicationMode.agent_portal.agency_address.show_has_same_postal_address_field',
  false,
);

export const zipCodeValidationRules = getConfig(
  'applicationMode.agent_portal.agency_address.validations.zip_code',
);

// onboarding
export const enabledSteps = getConfig(
  'applicationMode.agent_portal.onboarding.enabledSteps',
);
export const isOnboardingDisabled = getConfig(
  'applicationMode.agent_portal.onboarding.disabled',
);
export const isOnboardingTemporarilyDisabled = getConfig(
  'applicationMode.agent_portal.onboarding.temporarily_disabled',
);
export const isPrincipalAgentInfoEnabled = getConfig(
  'applicationMode.agent_portal.onboarding.is_principal_agent_info_enabled',
  false,
);
export const isWaitingForApproval = getConfig(
  'applicationMode.agent_portal.onboarding.is_waiting_for_approval',
);
export const approvedAgencyStatuses = getConfig(
  'applicationMode.agent_portal.onboarding.approved_statuses',
);
export const footerLinks = getConfig(
  'applicationMode.agent_portal.onboarding.footer_links',
);

//
export const isComplianceDisabled = getConfig(
  'applicationMode.agent_portal.compliance.disabled',
  false,
);
export const complianceEFTDocument = getConfig(
  'applicationMode.agent_portal.compliance.eft',
  {},
);
export const agreementTemplateUrl = getConfig(
  'applicationMode.agent_portal.compliance.agreement.template_url',
  '',
);
export const agreementTemplateName = getConfig(
  'applicationMode.agent_portal.compliance.agreement.template_name',
  '',
);
export const w9TemplateUrl = getConfig(
  'applicationMode.agent_portal.compliance.w9.template_url',
);

// tooltips
export const enabledTabNavigationTooltip = getConfig(
  'applicationMode.agent_portal.accounts.complex_tooltips.tab_navigation.enabled',
  false,
);
export const enabledAccountStatusTooltip = getConfig(
  'applicationMode.agent_portal.accounts.complex_tooltips.account_status.enabled',
  false,
);
export const enabledPolicyStatusTooltip = getConfig(
  'applicationMode.agent_portal.accounts.complex_tooltips.policy_status.enabled',
  false,
);

// table columns
export const agentsTableColumns = getConfig(
  'applicationMode.agent_portal.agents_table',
  [
    'name',
    'contact-info',
    'phone',
    'date-created',
    'last-activity',
    'performance',
  ],
);

export const commonStructureTableColumns = getConfig(
  'applicationMode.agent_portal.common_structure_table',
  [
    'account-name',
    'contact',
    'last-activity',
    'insurance-type',
    'industry',
    'status',
    'actions',
  ],
);

export const activeAccountsTableColumns = getConfig(
  'applicationMode.agent_portal.active_accounts_table',
  [
    'account-name',
    'contact',
    'last-activity',
    'insurance-type',
    'premium',
    'status',
    'actions-account',
  ],
);

export const renewalTableColumns = getConfig(
  'applicationMode.agent_portal.renewal_table',
  [
    'account-name',
    'contact',
    'last-activity',
    'insurance-type',
    'premium',
    'status',
    'actions-account',
  ],
);

/*
TO-DO: migrate getConfig use in: 
- src/components/pages/myAgency/agentInfo/AgentInfoForm.jsx
- src/hooks/useOnboarding.js
- src/utils/agencyStatusHelper.js
*/
